<template>
    <aside class="overlay-dialog" :class="bemFacets">
        <h1 class="overlay-dialog--title u-reset">
            {{ title }}
        </h1>

        <!-- eslint-disable-next-line vue/no-v-html -->
        <p class="overlay-dialog--text" v-html="text"/>


        <button type="button"
                class="btn btn__medium btn__primary"
                v-if="onAccept"
                @click="onAccept">
            {{ acceptLabel }}
        </button>

        <button type="button"
                class="btn btn__medium btn__primary"
                v-if="onDecline"
                @click="onDecline">
            {{ declineLabel }}
        </button>
    </aside>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapActions } from 'vuex';

    export default {
        mixins: [
            bemMixin('overlay-dialog'),
        ],
        props: {
            title: {
                type: String,
                required: true,
            },
            text: {
                type: String,
                required: true,
            },
            acceptLabel: {
                type: String,
                default: 'Accept',
            },
            onAccept: {
                type: Function,
                default: null,
            },
            onDecline: {
                type: Function,
                default: null,
            },
            declineLabel: {
                type: String,
                default: 'Decline',
            },
        },
        methods: {
            ...mapActions('vue-ui/overlay', ['closeOverlay']),
        },
    };
</script>
